<template>
    <div class="flex justify-center my-6">
        <div class="flex flex-col w-full text-center p-8 text-gray-800 bg-white shadow-lg pin-r pin-y md:w-4/5 lg:w-4/5">
            <p v-html="__('echec_lors_de_la_tentative_veuillez_reessayer', [{'key': 'transactionId', 'value': transactionId}])"></p>
            <inertia-link class="my-4 inline-block px-6 py-2 text-xs font-medium
                leading-6 text-center text-white uppercase max-w-xs
                mx-auto transition bg-cavilam-primary rounded shadow ripple
                hover:shadow-lg hover:opacity-95 focus:outline-none"
                :href="route('paiement.donneesPersonnelles')">{{ __('reessayer') }}</inertia-link>
        </div>
    </div>
</template>

<script>
import App from '@/Layouts/App'

export default {
    layout: App,
    name: "Echec",
    props: {
        transactionId: Number,
    },
}
</script>

<style scoped>

</style>
